module.exports = __webpack_public_path__ + "img/1.90d80011.jpg";